import mixpanel from 'mixpanel-browser';

// Configure Mixpanel to handle high-volume events better
export const configureMixpanel = () => {
  try {
    // Set batch configuration to reduce frequency of requests
    mixpanel.set_config({
      batch_requests: true,
      batch_size: 50,
      batch_flush_interval_ms: 5000, // Flush every 5 seconds instead of default 1 second
      loaded: function (mixpanel) {
        console.log('Mixpanel loaded with optimized configuration');
      },
      // Reduce verbosity to minimize console spam
      verbose: false,
      // Enable persistence to avoid data loss
      persistence: 'localStorage',
      // Increase timeout to prevent mutex issues
      api_timeout_ms: 10000 // 10 seconds timeout
    });

    console.log('Mixpanel configured for error tracking optimization');
  } catch (error) {
    console.warn('Error configuring Mixpanel:', error);
  }
};

export default configureMixpanel;
